var mentions_default = {
  "mentionPalette": "NS5WD",
  "mention": "-kVRU",
  "mentionViewer": "z1AAZ",
  "mentionSuggestionsEntry": "rzOeY",
  "mentionSuggestionsEntryFocused": "AehbW",
  "mentionSuggestionsEntryText": "VgbQD",
  "mentionSuggestionsEntryAvatar": "Sx313",
  "mentionSuggestions": "f8JlD",
  "cursorDefault": "_4Zzbl",
  "cursorPointer": "_5clX8"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions.scss.js.map
